module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersInStock":{"label":"Skladem"}}}')
  delete Component.options._Ctor
}
